import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TAPIStatus } from '@monorepo/types';

export type TUploadResponseDTO = {
  totalProcessedRows: number;
  successfulRows: number;
  failedRows: number;
  errors: number;
  errorFileKeyOpt?: string;
  errorFileKey?: string;
  errorMessageOpt?: string;
};

export type TUploadPdfResponseDTO = {
  status: TAPIStatus;
  errMsg?: string;
};

@Injectable({
  providedIn: 'root',
})
export class UploadDownLoadFileService {
  constructor(private http: HttpClient) {}

  downloadSampleTemplate(url: string, payload: any = null) {
    return this.http.post(url, payload, { responseType: 'blob' });
  }

  downloadAqlSampleTemplate(url: string, payload: any = null) {
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadSampleTemplateWithObserveResponse(url: string, payload: any = null) {
    return this.http.post(url, payload, { responseType: 'blob', observe: 'response' });
  }

  downloadSampleTemplateWithObserveResponseGET(url: string) {
    return this.http.get(url, { responseType: 'blob', observe: 'response' });
  }

  uploadExcel(url: string, formData: FormData) {
    return this.http.post<TUploadResponseDTO>(url, formData);
  }

  downloadErrorTemplate(url: string) {
    return this.http.post(url, null, { responseType: 'blob' });
  }

  downloadSampleTemplatePlani8(url: string, payload?: object) {
    if (payload) return this.http.post(url, payload, { responseType: 'blob' });
    else return this.http.get(url, { responseType: 'blob' });
  }

  downloadErrorTemplatePlani8(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadErrorTemplateWithObserveResponse(url: string) {
    return this.http.post(url, null, { responseType: 'blob', observe: 'response' });
  }

  uploadPdfFile(url: string, formData: FormData) {
    return this.http.post<TUploadPdfResponseDTO>(url, formData);
  }

  downloadPdfFileForViewing(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }
}
